import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../actions/Page/PageAction';
import {
  setPillsBugs,
  resetPillsBugs,
  fetchSearchInstitutions,
  openSearchFilterPanel,
  closeSearchFilterPanel,
  getAssociationSpecialtyById,
} from '../../actions/Users/UserAction';
import { getAddUserFormHeader, getUsersList } from '../../actions/Users/UserAction';
import Api from '../../Api';
import Constants from '../../Constants';
import Inputs from '../Common/Inputs/Inputs';
import Pagination from './components/Pagination/Pagination';
import { FocusToSearchResultContent, FocusToSearchResultNav } from '../Headers/SkipToContent';
import PillBugs from './components/PillBugs/PillBugs';
import SearchFilter from './components/SearchFilter';
import UsersTable from './components/UsersTable';
import { Loading } from './../Common/Loading';
import { createUsersSearchPayload } from '../../utils/search';
import { debounce } from '../../utils/decors';
import { Button } from '../Common';
import withNavigate from '../HOC/navigate';
import { REPORT_USER, SPECIALTY_USER } from '../../actionTypes/Users/UserActionType';
class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      modal: false,
      userRole: '',
    };
    this.focusToSearchResultRef = React.createRef();
  }

  async componentDidMount() {
    this.props.setPageTitle('Manage Users');
    this.props.setNavigateToMsg('Manage Users');
    this.props.fetchSearchInstitutions();
    // TODO: need to be optimized
    this.setState({
      searchTerm: this.props.usersList.terms.search,
    });

    this.props.getUsersList();
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  handlePagination = (pagination) => {
    this.props.getUsersList(pagination);
  };

  export = () => {
    const { terms } = createUsersSearchPayload(this.props.usersList);
    const reqData = {
      responseType: 'text/csv',
      body: {
        terms: {
          ...terms,
          internalUser:
            terms.internalUser && terms.internalUser.length > 0 ? terms.internalUser[0] === 'true' || null : null,
        },
      },
    };
    const api = new Api();
    const url = Constants.apiUrls.exportUsers;
    api.postData(url, reqData).then((resp) => {
      if (window.navigator.msSaveOrOpenBlob) {
        const blob = new Blob([resp]);
        window.navigator.msSaveOrOpenBlob(blob, 'users.csv');
      } else {
        const hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(resp);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'users.csv';
        hiddenElement.title = 'user data export';
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        hiddenElement.remove();
      }
    });
  };

  onSideFilterPanelClearAllFilters = () => {
    this.setState({
      searchTerm: '',
    });
  };

  doSearch = debounce(() => {
    this.props.getUsersList({
      pageSize: Constants.userListDefaultPageSize,
      pageNumber: 0,
      terms: {
        search: this.state.searchTerm,
      },
    });
  }, Constants.userListSearchInputDebounceMs);

  handleInputChange = (inputFields, value) => {
    this.setState({
      searchTerm: value,
    });
    this.doSearch();
  };

  render() {
    const { usersList, usersListLoading, userRoleConstant } = this.props;
    const length = usersList.contents ? usersList.contents.length : 0;
    return ![SPECIALTY_USER, REPORT_USER].includes(userRoleConstant) ? (
      <React.Fragment>
        <div tabIndex="-1" className="com-manage-users mLeft-15 mRight-45 mobile_margin init-focus__hidden">
          <div className="verticle-middle pTop-45 lineHeight-30">
            <div className="offset-md-3 col-sm-6 text-center fontSm-30">
              <h1 className="lsn-heading" id="app_page_title">
                Manage Users
              </h1>
            </div>
            <div className="col-sm-3 text-right">
              <Button
                isNew
                jelly
                disabled={this.props.disabled}
                onClick={() => this.props.navigate('/addUser')}
                appearance="secondary"
                size="small"
                text={getAddUserFormHeader(userRoleConstant)}
                id="button-users-add-new"
              />
            </div>
          </div>

          <FocusToSearchResultContent contentRef={this.focusToSearchResultRef} />
          <div className="search-bar">
            <Inputs
              onInputChange={this.handleInputChange}
              ariaLabel={'search users input'}
              name="search"
              type="search"
              placeholder="Search..."
              value={this.state.searchTerm}
              id="input-user-list-search"
            />
            <Button
              isNew
              aria-labelledby={'filterTitle'}
              onClick={() => this.props.openSearchFilterPanel()}
              appearance="secondary"
              size="small"
              shrank
              description={`For the best experience, activate focus mode when navigating the Filter menu. Use the up and down arrow
              keys to navigate between filter types. Use the enter key to expand or collapse that filter type. Use the
              tab key to select filter options. Lastly, use the ESC key to navigate to the close button. Click ESC
              again to close the Filter menu.`}
              icon="filter"
              id="button-users-filter-panel-open"
            />
            <FocusToSearchResultNav contentRef={this.focusToSearchResultRef} focusElId="manage-users-table-id" />
          </div>

          <PillBugs />

          {usersListLoading ? <Loading show classNames={['loading-users-list']} /> : void 0}

          {length === 0 && !usersListLoading ? (
            <div role="alert" className="centerIt verticle-middle">
              No Results. Please adjust your search and try again.
            </div>
          ) : (
            void 0
          )}

          {length > 0 ? (
            <React.Fragment>
              <div className={this.props.usersList.totalPages > 1 ? 'mTop-25 mBottom-45 ' : 'mYSm-5'}>
                <Pagination
                  onPagination={this.handlePagination}
                  export={this.export}
                  userRole={userRoleConstant}
                  title="Top Pagination"
                />
              </div>
              <span aria-live="polite" className="hide-by-pos">
                {`${this.props.usersList.totalElements} Results Total`}
              </span>
              <div className="listing mobile_margin fontSm-15">
                {userRoleConstant && (
                  <UsersTable
                    id="manage-users-table-id"
                    className="ScalaSansOT-Bold bold-font pointer"
                    tData={this.props.usersList.contents}
                    searchWords={this.state.searchTerm}
                    loggedAs={userRoleConstant}
                    onUserClick={(user) => {
                      const url = '/userDetails?guid=' + user.guid;
                      this.props.navigate(url);
                    }}
                    refreshUsers={() => {
                      this.props.getUsersList();
                    }}
                  />
                )}
              </div>
              <div className="mYSm-45">
                <Pagination
                  onPagination={this.handlePagination}
                  export={this.export}
                  userRole={userRoleConstant}
                  title="Bottom Pagination"
                  ariaOff
                />
              </div>
            </React.Fragment>
          ) : (
            void 0
          )}
        </div>
        <SearchFilter isOpen={this.props.isFilterPanelOpen} onClearAllFilters={this.onSideFilterPanelClearAllFilters} />
      </React.Fragment>
    ) : (
      <div>
        <h2>Invalid URL</h2>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    usersList: state.Users.usersList,
    usersListLoading: state.Users.loadingList,
    isFilterPanelOpen: state.Users.filterPanelOpen,
    userRoleConstant: state.AppSession.userDetails.userRoleConstant,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getUsersList,
      fetchSearchInstitutions,
      setPillsBugs,
      resetPillsBugs,
      setNavigateToMsg,
      setPageTitle,
      openSearchFilterPanel,
      closeSearchFilterPanel,
      getAssociationSpecialtyById,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(withNavigate(Users));
